/* eslint-disable no-eval, react/no-direct-mutation-state */
import React from 'react';
import { injectIntl, FormattedMessage } from "react-intl";
import { CheckBox } from 'devextreme-react/check-box';
import * as actionCrud from '../../../crud/action.crud';
import { Form, Item as FormItem, SimpleItem, GroupItem, RequiredRule, RangeRule, Label as FormLabel, ValidationRule } from 'devextreme-react/form';
import moment from 'moment';
import { withSnackbar } from 'notistack';
import { withRouter } from '../../../shared/hoc/withRouter';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import { dxDateBoxProps } from '../../../shared/config/DxFormProperties';
import { ValidationSummary, ValidationGroup } from 'devextreme-react';
import { Popover } from 'devextreme-react/popover';
import { Badge } from "react-bootstrap";
// import Validator, { RequiredRule, PatternRule } from 'devextreme-react/validator';
// import { GetManualActionTypes } from '../../../shared/lookup';

export const RESPONSE = {
    OK: 'OK',
    CANCEL: 'CANCEL',
    CREATE: 'CREATE'
};

class ActionModalPostAction extends React.Component {
    constructor(props) {
        super(props);
        let selectedPostActions = [];

        let userCreateSelectionExist = false;
        let { availableActionTypes } = this.props.contractTemplate;
        let possibleClearActionTypes = [];

        this.validatorRef = React.createRef();
        this.validatorName = 'ActionModalPostActionValidator';
        const { resources } = this.props.contractTemplate;

        if (this.props.mode === 'COMMUNICATE') {
            if (this.props.selectedClause?.postActions?.length > 0) {
                //CHECK POST-ACTION Definitions on clause item
                selectedPostActions = this.props.selectedClause.postActions;
            }
            possibleClearActionTypes.push("COMMUNICATE_NOTICE")
        }

        if (this.props.mode === 'REPLY_SEND') {
            if (this.props.selectedReply?.postActions?.length > 0) {
                //CHECK POST-ACTION Definitions on clause item
                selectedPostActions = this.props.selectedReply.postActions;
            }
        }

        const createActions = selectedPostActions
            .filter(act => (act.action === "CREATE" && availableActionTypes.some(typ => typ.value === act.actionType)))
            .map(act => {
                let daysForAction = 0;
                if ((act.timePeriod && act.timePeriod === "CUSTOM") || !act.timePeriod) {
                    daysForAction = act.daysForAction;
                }
                else {

                    if (resources.hasOwnProperty(act.timePeriod)) {
                        if (typeof resources[act.timePeriod] === "number") {
                            daysForAction = resources[act.timePeriod];
                        }
                    }
                }
                let display = `${availableActionTypes.find(typ => typ.value === act.actionType).display}`;
                let dueDate = null;
                if (act.timePeriod !== "ASK_ON_FORM") {
                    if (this.props.globalResources?.POST_ACTION_PAY_DATES_START_IF_APP_ONTIME === 'Assessment' && this.props.notificationDate) {
                        dueDate = moment(this.props.notificationDate).add(daysForAction, "days")._d
                    } else {
                        dueDate = moment().add(daysForAction, "days")._d
                    }
                }
                return {
                    ...act,
                    display,
                    daysForAction,
                    dueDate,
                    value: !act.askUser
                }
            });
        userCreateSelectionExist = createActions.some(act => !!act.askUser);

        const clearActionsOnSelection = selectedPostActions
            .filter(act => (act.action === "CLEAR" && availableActionTypes.some(typ => typ.value === act.actionType)));

        possibleClearActionTypes.push(...clearActionsOnSelection.map(x => x.actionType));

        this.state = {
            createActions,
            userCreateSelectionExist,
            availableActionTypes,
            possibleClearActionTypes,
            clearOptions: [],
            loadingClearItems: possibleClearActionTypes.length > 0,
            earliestRecurringClearActionID: 0
        }
    }

    componentDidMount(prevProps, prevState) {
        this.timer = setTimeout(() => {
            this.loadClearOptions();
        }, 500);
    }

    loadClearOptions = async () => {

        if (this.state.possibleClearActionTypes.length > 0) {
            // this.setState({ loadingClearItems: true }, async () => {
            try {
                const { data: clearOptions } = await actionCrud.loadClearActionOptions(this.props.contract.contractid, this.props.workflowItem.id, this.props.params.notificationid, this.state.possibleClearActionTypes);
                let earliestRecurringClearActionID = clearOptions.filter(a => !!a.recurring)[0]?.actionid;
                for (let index = 0; index < clearOptions.length; index++) {
                    clearOptions[index].defaultValue = (!!clearOptions[index].relationtosourceexist || clearOptions[index].actionid === this.state.earliestRecurringClearActionID);
                    this.props.formRef.current.instance().updateData("CLEAR_" + clearOptions[index].actionid, clearOptions[index].defaultValue);
                }
                this.setState({ clearOptions, earliestRecurringClearActionID, loadingClearItems: false })
            } catch (err) {
                console.log(err)
                this.setState({ clearOptions: [], earliestRecurringClearActionID: 0, loadingClearItems: false })
                this.props.enqueueSnackbar("Failed to load clear actions: " + err.toString(), { variant: 'error', });
            }
            // });
        }
    }

    onClearItemSourceURLClick = (clearOption, e) => {
        if (e) { e.preventDefault() };
        if (clearOption.sourceworkflowid && clearOption.sourcerecordid) {
            if (this.props.contractTemplate.workflowsQA[clearOption.sourceworkflowid]) {
                if (this.props.contractTemplate.workflowsQA[clearOption.sourceworkflowid].paths?.basePath) {
                    let navURL = this.props.contractTemplate.workflowsQA[clearOption.sourceworkflowid].paths.basePath + clearOption.sourcerecordid
                    if (e) {
                        this.props.navigate(navURL);
                    }
                    else {
                        return navURL;
                    }

                }
            }
        }
    }
    handleCheckBoxValueChange = (clearOption, e) => {
        this.props.formRef.current.instance().updateData("CLEAR_" + clearOption.actionid, e.value)
    }
    formFieldDataChanged = (e) => {
        try {
            this.formData = e.component.option("formData");
            if (e.dataField.startsWith("CLEAR_")) {
                //no assignment needed
                return;
            }
            if (e.dataField.startsWith("DD_")) {
                const postCreateAction = this.state.createActions.find(act => "DD_" + act.actionType === e.dataField);
                if (postCreateAction.dueDate !== e.value) {
                    postCreateAction.dueDate = e.value;
                    this.setState({ createActions: [...this.state.createActions] })
                }
            }
            else {
                const postCreateAction = this.state.createActions.find(act => act.actionType === e.dataField)
                if (postCreateAction.value !== e.value) {
                    postCreateAction.value = e.value;
                    if (postCreateAction.value === false && postCreateAction.timePeriod === "ASK_ON_FORM") {
                        postCreateAction.dueDate = null;
                    }
                    this.setState({ createActions: [...this.state.createActions] })
                }
                // 
            }
        } catch (err) {
            console.log(err)
            this.props.enqueueSnackbar("formFieldDataChanged: " + err.toString(), { variant: 'error', });
        }

        // e.component.updateData("ownerparty", typeWF.notifyingParty)
        // this.setState({createActions:{...this.state.createActions}})
    }

    render() {

        if (this.props.mode === 'COMMUNICATE' || this.props.mode === 'REPLY_SEND') {
            return (
                <>
                    <Form
                        ref={this.props.formRef}
                        showValidationSummary={true}
                        onFieldDataChanged={this.formFieldDataChanged}
                    // onFormDataChange={this.formFieldDataChanged}
                    // onOptionChanged={this.onOptionChanged}
                    >
                        {
                            this.state.createActions.length > 0 && (
                                <GroupItem caption={`${this.props.intl.formatMessage({ id: "ACTION.MODAL.CREATE_PENDING_TITLE" })}${this.state.userSelectionExist ? ` ${this.props.intl.formatMessage({ id: "ACTION.MODAL.CREATE_PENDING_SELECT_OPTION" })}` : ""}`}>
                                    {
                                        this.state.createActions.map((postAction, index) =>
                                        (
                                            <GroupItem key={"CREATE_GRP_" + index} colCount={3}>
                                                <FormItem
                                                    colSpan={2}
                                                    visible={true}
                                                    label={{ visible: false }}
                                                    dataField={postAction.actionType}
                                                    editorType='dxCheckBox'

                                                    editorOptions={{
                                                        text: postAction.display,
                                                        readOnly: !postAction.askUser,
                                                        hoverStateEnabled: !!postAction.askUser,
                                                        value: postAction.value
                                                    }}
                                                />
                                                <FormItem
                                                    colSpan={1}
                                                    label={{ text: this.props.intl.formatMessage({ id: 'GENERAL.WORDS.DUE' }) }}
                                                    dataField={"DD_" + postAction.actionType}
                                                    editorType="dxDateBox"
                                                    editorOptions={{
                                                        ...dxDateBoxProps,
                                                        min: moment()._d,
                                                        max: moment().add(10, 'years')._d,
                                                        calendarOptions: {
                                                            firstDayOfWeek: 1,
                                                            min: moment()._d,
                                                            max: moment().add(10, 'years')._d,
                                                        },
                                                        readOnly: postAction.timePeriod !== "ASK_ON_FORM",
                                                        value: postAction.dueDate

                                                    }}
                                                    isRequired={!!postAction.value}
                                                >
                                                    {
                                                        !!postAction.value && (
                                                            <RequiredRule message={this.props.intl.formatMessage({ id: 'GENERAL.VALIDATION.DUE_DATE_REQUIRED' }) + ": " + postAction.display} />
                                                        )
                                                    }

                                                </FormItem>


                                            </GroupItem>
                                        ))
                                    }

                                </GroupItem>
                            )
                        }
                        {
                            this.state.clearOptions.length > 0 && (
                                <GroupItem caption={this.props.intl.formatMessage({ id: "ACTION.MODAL.CLEAR_PENDING_TITLE" })}>
                                    {
                                        this.state.clearOptions.map((clearOption, index) =>
                                        (
                                            <SimpleItem
                                                key={"CLEAR_" + index}
                                                visible={true}
                                                label={{ visible: false }}
                                                dataField={"CLEAR_" + clearOption.actionid}
                                                editorType='dxCheckBox'
                                            // render={this.renderChackbox.bind(this, clearOption)}
                                            // editorOptions={{
                                            //     text: "[" + moment(clearOption.duedate).format('DD/MM/YYYY') + "] " + clearOption.subject,
                                            //     hoverStateEnabled: true,
                                            //     defaultValue: false
                                            // }}
                                            >
                                                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                                                    <CheckBox
                                                        style={{ display: "flex" }}
                                                        text={`[${moment(clearOption.duedate).format('DD/MM/YYYY')}] ${clearOption.subject}${clearOption.recurring ? " [R]" : ""}`}//+this.state.availableActionTypes.find(typ => typ.value === clearOption.actiontype).display ,
                                                        hoverStateEnabled={true}
                                                        defaultValue={clearOption.defaultValue}
                                                        onValueChanged={this.handleCheckBoxValueChange.bind(this, clearOption)}
                                                        readOnly={(clearOption.creationsource === 1 && !!clearOption.defaultValue)} // is system action & auto selected, do not let remove the tick
                                                    // disabled={(!clearOption.defaultValue && clearOption.creationsource === 1)}
                                                    />

                                                    {
                                                        clearOption.sourceworkflowid && clearOption.sourcerecordid && (
                                                            <a style={{ display: "flex" }} href={this.onClearItemSourceURLClick(clearOption)} onClick={this.onClearItemSourceURLClick.bind(this, clearOption)} className="kt-nav__link">
                                                                <i id="linkToClear" className="dx-icon dx-icon-link align-middle ml-2" style={{ fontSize: '20px' }}></i>
                                                            </a>
                                                        )
                                                    }
                                                    {/*
                                                        (!clearOption.defaultValue && clearOption.creationsource === 1) && (
                                                            <>
                                                                <Badge style={{ cursor: "pointer" }} variant="warning" id='link4'>Disabled</Badge>
                                                                <Popover
                                                                    target="#link4"
                                                                    showEvent="click"
                                                                    position="top"
                                                                    width={300}
                                                                    shading={true}
                                                                    shadingColor="rgba(0, 0, 0, 0.5)"
                                                                >
                                                                    The system generated actions require a relation to generation source in order to clear the action
                                                                </Popover>
                                                            </>
                                                        )
                                                    */}
                                                </div>
                                            </SimpleItem>

                                        ))
                                    }


                                </GroupItem>
                            )
                        }

                    </Form>
                    {
                        this.state.loadingClearItems && (
                            <div style={{ display: 'flex', flexDirection: 'column', textAlign: "center" }}>
                                <LoadIndicator
                                    id="medium-indicator"
                                    style={{ alignSelf: "center" }}
                                    height={40}
                                    width={40}
                                />
                                <span>
                                    <FormattedMessage id="ACTIONS.INFO.LOADING_CLEAR_ITEMS" />
                                </span>
                            </div>
                        )
                    }
                </>
            )
        }
        else { return null; }
    }
}



export default withRouter(withSnackbar(injectIntl(ActionModalPostAction)));